import { getConfig } from '../configs/config';
import messages from '../constants/logMessages.json';
import queue from '../storage/queue';
import {
  AnalyticsPageView,
  AnalyticsSelectItemEcommerce,
  AnalyticsStandardEvent,
  AnalyticsViewItemEcommerce,
  AnalyticsViewItemListEcommerce,
  ApiError,
  Purchase,
} from '../types';
import {
  BusinessErrorPayload,
  ErrorPayload,
  TechnicalErrorPayload,
  ValidationErrorPayload,
} from '../types/errors';
import { jsonToString } from '../utils/analyticsUtils';
import logging, { getMessage } from '../utils/logging';
import * as events from './event';

const { errorHeading, errorBold } = messages;

export const push = (payload: object) => {
  const { status } = getConfig();
  const { enqueue } = queue(getConfig());

  if (!status) return;

  try {
    // Push in the queue.
    enqueue(payload);
  } catch (e) {
    logging.error(
      getMessage('catchError', ['enqueue', jsonToString([e as object])]),
      errorHeading,
      errorBold
    );
  }
};

/**
 * Tracking Connectors for React Hooks.
 * @param {*} context
 */
const analyticsPageView = (context: AnalyticsPageView) => {
  push(events.pageView(context));
};

const analyticsCustomEvent = (context: AnalyticsStandardEvent) => {
  push(events.customEvent(context));
};
const analyticsClick = (context: AnalyticsStandardEvent) => {
  push(events.clickTracking(context));
};

const analyticsBusinessError = (context: BusinessErrorPayload) => {
  push(events.businessError(context));
};

const analyticsTechnicalError = (context: TechnicalErrorPayload) => {
  push(events.technicalError(context));
};

const analyticsApiError = (context: ApiError) => {
  push(events.apiError(context));
};

const analyticsEngagementTracking = (context: AnalyticsStandardEvent) => {
  push(events.engagementTracking(context));
};

const analyticsEcommercePurchase = (context: Purchase) => {
  push(events.eCommercePurchase(context));
};

const analyticsEcommerceViewItemList = (
  context: AnalyticsViewItemListEcommerce
) => {
  push(events.eCommerceViewItemList(context));
};

const analyticsEcommerceViewItem = (context: AnalyticsViewItemEcommerce) => {
  push(events.eCommerceViewItem(context));
};

const analyticsECommerceSelectItemEvent = (
  context: AnalyticsSelectItemEcommerce
) => {
  push(events.eCommerceSelectItem(context));
};

const analyticsGeneralError = (context: ErrorPayload) => {
  push(events.generalError(context));
};

const analyticsValidationError = (context: ValidationErrorPayload) => {
  push(events.validationError(context));
};

const analyticsAlertError = (context: ErrorPayload) => {
  push(events.alertError(context));
};

const tracking = {
  analyticsPageView,
  analyticsCustomEvent,
  analyticsClick,
  analyticsBusinessError,
  analyticsTechnicalError,
  analyticsEngagementTracking,
  analyticsEcommercePurchase,
  analyticsEcommerceViewItemList,
  analyticsECommerceSelectItemEvent,
  analyticsEcommerceViewItem,
  analyticsGeneralError,
  analyticsApiError,
  analyticsAlertError,
  analyticsValidationError,
};

export default tracking;
